import React, { Component } from 'react';
import './NavBar.scss';
import { Link } from 'gatsby';
import LinkButton from '../LinkButton/LinkButton';
import getURLParams from '../../helpers/getURLParams';
const logo = require('../../assets/icons/dochq-logo-rect.svg');
const menuIcon = require('../../assets/icons/menu.svg');
// TODO! Swap nav-items to include links,
//TODO! add active classes,
//TODO! show and hide links based on personal or business
//TODO! Dropdown for mobile with covid-19 accordion style thing
//TODO! Dropdown for covid-19
export default class NavBar extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dropdownOpen: false,
			business: false,
			addedAwin: false,
			topActive: 'personal',
		};
		this.getURLParams = getURLParams.bind(this);
		this.isBusiness = isBusiness.bind(this);
		this.setBusiness = setBusiness.bind(this);
		this.handleScroll = handleScroll.bind(this);
		function isBusiness(urlParams) {
			const personalURLs = [
				'contact-us',
				'covid-19-home-test-kit',
				'travel-vaccine',
				'drug-restrictions',
			];
			let isBusiness = true;
			if (typeof window !== 'undefined') {
				if (personalURLs.find(url => urlParams.includes(url)) !== undefined) {
					isBusiness = false;
				}
			}
			return isBusiness;
		}
		function setBusiness(state) {
			this.setState({ business: state });
			window.sessionStorage.setItem('business', state);
		}
		function handleScroll(event) {
			// User has scrolled, hide dropdown;
			if (this.state.dropdownOpen) {
				this.setState({ dropdownOpen: false });
			}
		}
	}
	componentWillMount() {
		if (typeof window !== `undefined`) {
			window.addEventListener('scroll', this.handleScroll);
		}
	}
	componentDidMount() {
		if (this.isBusiness(window.location.href)) {
			this.setBusiness(true);
			this.setState({
				topActive: 'business',
			});
		} else {
			//could be personal or contact-us
			let contactUs = 'contact-us';
			if (window.location.href.includes(contactUs)) {
				if (window.sessionStorage.getItem('business') !== null) {
					var business = window.sessionStorage.getItem('business') === 'true';
					this.setBusiness(business);
				}
				this.setState({
					topActive: 'contact-us',
				});
			} else {
				//personal urls
				this.setBusiness(false);
				this.setState({
					topActive: 'personal',
				});
			}
		}
	}
	componentWillUnmount() {
		if (typeof window !== `undefined`) {
			window.removeEventListener('scroll', this.handleScroll);
		}
	}
	render() {
		if (this.state.addedAwin === false && typeof window !== 'undefined') {
			let body = document.getElementsByTagName('body')[0];

			let awMastertag = document.createElement('script');
			awMastertag.setAttribute('defer', 'defer');
			awMastertag.src = 'https://www.dwin1.com/19181.js';
			awMastertag.type = 'text/javascript';

			body.appendChild(awMastertag);

			this.setState({ addedAwin: true });
		}
		if (
			typeof sessionStorage !== 'undefined' &&
			typeof sessionStorage.getItem('cookiesShown') !== 'undefined' &&
			sessionStorage.getItem('cookiesShown') !== true
		) {
			var _iub = _iub || [];

			_iub.csConfiguration = {
				lang: 'en',
				siteId: 1807825,
				gdprAppliesGlobally: false,
				consentOnScroll: false,
				whitelabel: false,
				cookiePolicyId: 47439358,
				banner: {
					acceptButtonDisplay: true,
					customizeButtonDisplay: true,
					position: 'float-top-center',
					textColor: 'white',
					backgroundColor: '#333333',
					acceptButtonColor: '#e5014d',
					acceptButtonCaptionColor: 'white',
					customizeButtonColor: '#212121',
					customizeButtonCaptionColor: 'white',
				},
			};
			typeof window !== 'undefined' ? (window._iub = _iub) : null;
			console.log('iub config sessionstorage');
			sessionStorage.setItem('cookiesShown', true);
		}
		return (
			<React.Fragment>
				<nav role='navigation'>
					<div className='navigation-container'>
						<div className='row-nav top-nav-row'>
							<TopNavLinks
								props
								topActive={this.state.topActive}
								setBusiness={this.setBusiness}
								setActive={active => this.setState({ topActive: active })}
							/>
						</div>
						<div className='row-nav nav-row'>
							<Link to={this.state.business ? '/' : '/travel-vaccine'} style={{ height: '100%' }}>
								<div className='logo'>
									<img src={logo} alt='DocHQ Logo' />
								</div>
							</Link>
							{this.state.business && <BusinessLinks props />}
							{!this.state.business && <FamiliesLinks props />}

							<div
								className='menu-bar display-on-sm'
								role='navigation'
								onClick={() => {
									this.setState({ dropdownOpen: true });
								}}
							>
								{!this.state.dropdownOpen && (
									<img src={menuIcon} alt='Menu Dropdown Toggle' width='40px' />
								)}
							</div>
						</div>
					</div>
					<MobileDropdown
						props
						business={this.state.business}
						active={this.state.dropdownOpen}
						closeDropdown={() => {
							this.setState({ dropdownOpen: false });
						}}
					/>
				</nav>
			</React.Fragment>
		);
	}
}
const BusinessLinks = () => (
	<React.Fragment>
		<div className='nav-item'>
			<Link to='/how-doc-hq-works' activeClassName='active'>
				How it Works
			</Link>
		</div>
		<div className='nav-item'>
			<Link to='/packages' activeClassName='active'>
				Pricing
			</Link>
		</div>
		<div className='nav-item'>
			<Link to='/faqs' activeClassName='active'>
				FAQs
			</Link>
		</div>
		<div className='nav-item'>
			<LinkButton text='Login' linkSrc='https://dochq.health/users/login' color='pink' />
		</div>
	</React.Fragment>
);

const FamiliesLinks = () => (
	<React.Fragment>
		<div className='nav-item'>
			<Link to='/travel-vaccine' activeClassName='active'>
				Travel Vaccines
			</Link>
		</div>
		<div className='nav-item'>
			<Link to='/travel-medicine-restrictions'>Travel Medicines</Link>
		</div>
		{/*<div className='nav-item'>
			<Link to='/covid-19-home-test-kit' activeClassName='active'>
				Covid-19
			</Link>
		</div>*/}
	</React.Fragment>
);
const TopNavLinks = ({ topActive, setBusiness, setActive }) => (
	<React.Fragment>
		<Link
			to='/travel-vaccine'
			className={`top-nav-item ${topActive === 'personal' ? 'active' : ''}`}
			onClick={() => {
				setBusiness(false);
				setActive('personal');
			}}
		>
			Personal
		</Link>

		<Link
			to='/'
			className={`top-nav-item ${topActive === 'business' ? 'active' : ''}`}
			onClick={() => {
				setBusiness(true);
				setActive('business');
			}}
		>
			Business
		</Link>

		<Link
			to='/contact-us'
			className={`top-nav-item ${topActive === 'contact-us' ? 'active' : ''}`}
			onClick={() => {
				setActive('contact-us');
			}}
		>
			Contact Us
		</Link>
	</React.Fragment>
);

const MobileDropdown = props => (
	<React.Fragment>
		<div className={`mobile-dropdown-all-container ${props.active ? 'active' : ''}`}>
			<div
				className={`mobile-dropdown-container ${props.active ? 'active' : ''}`}
				role='navigation'
			>
				<div className='mobile-dropdown'>
					{props.business && <BusinessLinks props />}
					{!props.business && <FamiliesLinks props />}
				</div>
				<div className='mobile-dropdown-close' onClick={() => props.closeDropdown()}>
					<i className='fa fa-chevron-up fa-2x'></i>
				</div>
			</div>
			<div
				className={`mobile-dropdown-scroll-stop ${props.active ? 'active' : ''}`}
				onClick={() => props.closeDropdown()}
			></div>
		</div>
	</React.Fragment>
);
